export default {
  gdprBlock: {
    position: "fixed",
    bottom: "0",
    width: "100%",
    backgroundColor: "#FFF",
    height: "auto",
    zIndex: "5000",
    borderTop: "1px solid #000",
    letterSpacing: "0.05em",
    color: "#444 !important",
    textAlign: "center",
    display: "block",
    padding: "30px"
  },
  textBlock: {
    maxWidth: "80%",
    width: "80%",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: "17px",
    fontWeight: "700",
    fontFamily: "sans-serif"
  },
  link: {
    color: "#444",
    borderBottom: "1px dashed #444",
    textDecoration: "none"
  },
  button: {
    textTransform: "uppercase",
    boxShadow: "none",
    borderRadius: "2px",
    backgroundColor: "#a7d233",
    backgroundImage: "none",
    textShadow: "none",
    border: "1px solid #a7d233",
    padding: "0.5em 2em",
    margin: "17px",
    fontWeight: "bold",
    fontSize: "17px",
    letterSpacing: "0.05em"
  }
};
